import 'leaflet'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-measure-path'

export default {
  mounted () {
    this.initMeasure()
  },
  methods: {
    getDrawLocales () {
      return {
        draw: {
          toolbar: {
            actions: {title: "Отменить", text: "Отменить"},
            finish: {title: "Закончить", text: "Закончить"},
            undo: {title: "Удалить последнюю точку", text: "Удалить последнюю точку"},
            buttons: {
              polyline: "Линия",
              polygon: "Многоугольник",
              rectangle: "Прямоугольник",
              circle: "Круг",
              marker: "Метка",
              circlemarker: "Круглая метка"
            }
          },
          handlers: {
            circle: {tooltip: {start: "Кликните и удерживая кнопку мыши начните перемещать мышку чтобы нарисовать круг."}, radius: "Радиус"},
            circlemarker: {tooltip: {start: "Click map to place circle marker."}},
            marker: {tooltip: {start: "Click map to place marker."}},
            polygon: {
              tooltip: {
                start: "Кликните по карте чтобы начать рисовать фигуру.",
                cont: "Кликните по карте чтобы продолжить рисовать фигуру.",
                end: "Кликните по первой точке фигуры чтобы закончить."
              }
            },
            polyline: {
              error: "<strong>Ошибка:</strong> края не должны пересекаться!",
              tooltip: {
                start: "Кликните чтобы нарисовать линию.",
                cont: "Кликните чтобы продолжить рисовать.",
                end: "Кликните по последней точке чтобы перестать рисовать."
              }
            },
            rectangle: {tooltip: {start: "Кликните и удерживая кнопку мыши начните перемещать мышку чтобы нарисовать круг."}},
            simpleshape: {tooltip: {end: "Отпустите кнопку мыши чтобы закончить."}}
          }
        },
        edit: {
          toolbar: {
            actions: {
              save: {title: "Сохранить изменения", text: "Сохранить"},
              cancel: {title: "Отмена, все изменения будут удалены", text: "Отмена"},
              clearAll: {title: "Удалить все", text: "Удалить все"}
            },
            buttons: {
              edit: "Отредактировать",
              editDisabled: "Нет ничего для редактирования",
              remove: "Удалить",
              removeDisabled: "Нет ничего для удаления"
            }
          },
          handlers: {
            edit: {
              tooltip: {
                text: "Перетаскивайте метки на ребрах для редактирования.",
                subtext: "Нажмите отмена чтобы вернуться к предыдущему состоянию."
              }
            },
            remove: {tooltip: {text: "Кликните что по нарисованому объекту чтобы удалить его."}}
          }
        }
      }
    },
    getShapeOptions () {
      return {
        stroke: true,
        color: '#3388ff',
        weight: 4,
        opacity: 0.5,
        clickable: true,
        dashArray: null,
        dashOffset: null
      }
    },
    // for extend in childs components
    getDrawControlOptions () {
      const shapeOptions = this.getShapeOptions()
      return {
        draw: {
          marker: false,
          circlemarker: false,
          polyline: {
            shapeOptions
          },
          polygon: {
            shapeOptions
          },
          rectangle: {
            shapeOptions
          },
          circle: {
            shapeOptions
          }
        },
        edit: {
          featureGroup: this.editableLayers
        }
      }
    },
    initMeasure () {
      this.editableLayers = new L.FeatureGroup()
      this.map.addLayer(this.editableLayers)
      // see https://github.com/Leaflet/Leaflet.draw
      L.drawLocal = Object.assign({}, this.getDrawLocales())
      this.drawControl = new L.Control.Draw(this.getDrawControlOptions())
      this.map.addControl(this.drawControl)
      this.map.on(L.Draw.Event.CREATED, this.onDrawObjectCreated)
      this.addMeasureUpdateListeners()
      this.map.on(L.Draw.Event.EDITSTOP, this.onEditStop)
    },
    // TODO: recreate poly
    onEditStop (e) {
      this.editableLayers.eachLayer((layer) => {
        L.setOptions(layer, this.getShapeOptions())
      })
    },
    addMeasureUpdateListeners () {
      let evts = [
        'dragend',
        'touchmove',
        'MSPointerMove',
        'touchend',
        'MSPointerUp'
      ]
      evts.forEach(evtName => {
        this.map.on(evtName, () => {
          if (this.editableLayers) {
            this.editableLayers.eachLayer((layer) => {
              layer.updateMeasurements()
            })
          }
        })
      })
    },
    onDrawObjectCreated (e) {
      let {layer} = e
      this.editableLayers.addLayer(layer)
      layer.showMeasurements(this.getMeasurementOptions())
    },
    // see https://github.com/ProminentEdge/leaflet-measure-path
    getMeasurementOptions () {
      return {
        lang: {
          totalLength: 'Общая длина',
          totalArea: 'Общая площадь',
          segmentLength: 'Длина отрезка'
        },
        formatDistance: (d) => {
          let unit = 'м'
          if (d > 1000) {
            d = d / 1000
            unit = 'км'
          }
          if (d < 100) {
            return d.toFixed(1) + ' ' + unit
          } else {
            return Math.round(d) + ' ' + unit
          }
        },
        formatArea: (a) => {
          let unit = 'м²'
          let adtA = a / 100
          let adtUnit = 'соток'
          if (a > 1000000) {
            a = a / 1000000
            unit = 'км²'
            adtA = a * 100
            adtUnit = 'Га'
          }
          if (a < 100) {
            return a.toFixed(1) + ' ' + unit + ' / ' + adtA.toFixed(1) + ' ' + adtUnit
          } else {
            return Math.round(a) + ' ' + unit + ' / ' + Math.round(adtA) + ' ' + adtUnit
          }
        }
      }
    }
  }
}
